/**
 * Shared helpers used across Control Room tab modules.
 * Extracted from AdminControlRoom.jsx to keep individual tab files
 * small and independently testable.
 */
import React, { useEffect, useState } from "react";
import api from "@/lib/api";

export const DRIVER_EXPENSE_TYPES = ["FUEL", "MAINTENANCE", "TOLL", "PARKING", "OTHER"];
export const OVERHEAD_TYPES = ["LEASE", "SOCIAL_FEE", "INSURANCE", "FLEET_FUEL", "FLEET_MAINT", "PLATFORM_FEE", "OTHER"];

export const PLATFORM_COLORS = { UBER: "#e5e5e5", BOLT: "#84cc16", PRIVATE: "#10b981" };

export function useDrivers() {
  const [drivers, setDrivers] = useState([]);
  useEffect(() => {
    api.get("/admin/drivers").then(({ data }) => setDrivers(data || []))
      .catch(() => setDrivers([]));
  }, []);
  return drivers;
}

/** Returns 'YYYY-Www' for a JS Date (ISO week — Mon–Sun). */
export function isoWeekOf(d) {
  const t = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  const dayNum = t.getUTCDay() || 7;
  t.setUTCDate(t.getUTCDate() + 4 - dayNum);
  const yearStart = new Date(Date.UTC(t.getUTCFullYear(), 0, 1));
  const week = Math.ceil((((t - yearStart) / 86400000) + 1) / 7);
  return `${t.getUTCFullYear()}-W${String(week).padStart(2, "0")}`;
}

export function Fact({ k, v }) {
  return (
    <div>
      <p className="text-[10px] uppercase tracking-widest text-zinc-500">{k}</p>
      <p className="text-zinc-200 truncate">{String(v)}</p>
    </div>
  );
}

export function Kpi({ label, value, tone = "default", big }) {
  const toneClasses = {
    default: "border-white/10 text-zinc-100",
    muted: "border-white/10 text-zinc-400",
    accent: "border-[#C5A059]/40 text-[#C5A059] bg-[#C5A059]/5",
    warn: "border-orange-500/40 text-orange-300 bg-orange-500/5",
    good: "border-emerald-500/40 text-emerald-300 bg-emerald-500/5",
    bad: "border-red-500/40 text-red-300 bg-red-500/5",
  }[tone] || "border-white/10 text-zinc-100";
  return (
    <div className={`rounded-2xl border p-4 ${toneClasses}`} data-testid={`kpi-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
      <p className="text-[10px] uppercase tracking-[0.25em] opacity-70">{label}</p>
      <p className={`font-display tabular-nums mt-1 ${big ? "text-3xl" : "text-2xl"}`}>
        €{Number(value).toFixed(2)}
      </p>
    </div>
  );
}

export function FormField({ label, value, onChange, testid, required }) {
  return (
    <label className="block">
      <span className="text-[10px] uppercase tracking-[0.2em] text-zinc-500">{label}{required && " *"}</span>
      <input value={value} onChange={(e) => onChange(e.target.value)}
             data-testid={testid} required={required}
             className="mt-1 w-full h-10 bg-zinc-900 border border-white/10 rounded-lg px-3 text-sm text-white" />
    </label>
  );
}
